import twemoji from 'twemoji';
import { CONTENT_CAPTION_COLOR } from '@/composable/constant_common';
import emojiRegex from 'emoji-regex';

/**
 * テロップ画像とURLを作成する処理
 */
// eslint-disable-next-line import/prefer-default-export
export async function createContentCaptionPng(canvas, contentCaption, contentCaptionColor) {
  const ctx = canvas.getContext('2d');

  // フォントサイズを固定
  const fontSize = 128;
  ctx.font = `${fontSize}px Arial`;

  // テキストメトリクスを取得
  const metrics = ctx.measureText(contentCaption);
  // テキストの幅と高さを取得
  const textWidth = metrics.width;

  // 行数を計算
  const lines = contentCaption.split('\n');
  const lineCount = lines.length;

  // キャンバスの高さを行数に応じて設定
  // eslint-disable-next-line no-param-reassign
  canvas.height = lineCount * 128 + 20;
  // キャンバスのサイズをテキストのサイズに設定（絵文字のサイズも考慮）
  // eslint-disable-next-line no-param-reassign
  canvas.width = textWidth * 1.5;

  // キャンバスをクリア
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Twemojiを使ってテキストを解析
  const parsedText = twemoji.parse(contentCaption, {
    folder: 'svg',
    ext: '.svg',
    base: 'https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/',
    attributes: () => ({ crossOrigin: 'anonymous' }),
  });

  // 一時的なdivを作成して解析されたテキストをレンダリング
  const tempDiv = document.createElement('div');
  // テキストを非表示に設定
  tempDiv.style.display = 'none';
  tempDiv.innerHTML = parsedText;
  document.body.appendChild(tempDiv);

  // テキストをキャンバスにレンダリング
  const yOffset = 120;
  let xOffset = 0;
  const lineHeight = 20;
  const nodes = Array.from(tempDiv.childNodes);

  // テキストと画像の描画を順番に処理する関数
  const drawNodesSequentially = async (nodeList) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const node of nodeList) {
      if (node.nodeType === Node.TEXT_NODE) {
        // テキストの時の処理
        ctx.font = '128px Arial';
        // 文字の縁の太さを設定
        ctx.lineWidth = 1;
        // 文字の縁の色を設定
        if (contentCaptionColor === CONTENT_CAPTION_COLOR.white) {
          ctx.strokeStyle = CONTENT_CAPTION_COLOR.black;
        } else {
          ctx.strokeStyle = CONTENT_CAPTION_COLOR.white;
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const char of node.textContent) {
          if (char === '\n') {
            // yOffset += 1
            // xOffset = 0;
          } else {
            ctx.fillStyle = contentCaptionColor;
            ctx.fillText(char, xOffset, yOffset);
            ctx.strokeText(char, xOffset, yOffset);
            xOffset += ctx.measureText(char).width;
          }
        }
      } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'IMG') {
        // 絵文字の時の処理
        // eslint-disable-next-line no-await-in-loop, no-loop-func
        await new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = 'anonymous'; // CORS対応
          img.src = node.src;
          img.onload = () => {
            ctx.drawImage(img, xOffset, yOffset - fontSize + lineHeight * 0.7, 128, 128);
            xOffset += 128; // 絵文字の幅に合わせてxOffsetを調整
            resolve();
          };
        });
      }
    }
  };
  // すべてのノードを順番に描画
  await drawNodesSequentially(nodes);

  // 一時的なdivを削除
  document.body.removeChild(tempDiv);

  // 画像のバイナリデータを取得
  const dataUrl = canvas.toDataURL('image/png');

  // canvasサイズを初期化
  // eslint-disable-next-line no-param-reassign
  canvas.width = 0;
  // eslint-disable-next-line no-param-reassign
  canvas.height = 0;

  return dataUrl;
}

/**
 * 文字列を絵文字とテキストに分割する関数
 */
export function splitByEmoji(str) {
  const regex = emojiRegex(); // 絵文字を判定する正規表現
  const result = []; // 分割結果を格納する配列
  let lastIndex = 0; // 前回の処理位置

  // 文字列内のすべての絵文字を順に検知し処理する
  str.replace(regex, (match, offset) => {
    // 絵文字より前にテキストがあればresultに追加
    if (offset > lastIndex) {
      result.push({ type: 'text', content: str.slice(lastIndex, offset) });
    }

    // 見つかった絵文字をresultに追加
    result.push({ type: 'emoji', content: match });
    // lastIndexを今回の絵文字の直後に更新
    lastIndex = offset + match.length;

    return match;
  });

  // 最後の絵文字より後ろにテキストがあればresultに追加
  if (lastIndex < str.length) {
    result.push({ type: 'text', content: str.slice(lastIndex) });
  }

  return result;
}
